import { render, staticRenderFns } from "./ContactTabOfPublicTender.vue?vue&type=template&id=f6f23102&scoped=true&"
import script from "./ContactTabOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./ContactTabOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./ContactTabOfPublicTender.vue?vue&type=style&index=0&id=f6f23102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f23102",
  null
  
)

export default component.exports